'use es6';

import { AssetTypes } from 'ContentComponents/constants/AssetTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import UICardHero from 'UIComponents/card/UICardHero';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { Flex } from 'foundations-components/components/Flex';
import H5 from 'UIComponents/elements/headings/H5';
import UIImage from 'UIComponents/image/UIImage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { makeSpacedComponent } from 'ContentComponents/cmv2/components/SpacedComponent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.themes.assetCard.${key}`;
const SizedCardHero = styled(UICardHero).withConfig({
  displayName: "AssetCard__SizedCardHero",
  componentId: "n5is04-0"
})(["max-height:270px;height:270px;"]);
const SelectableBox = styled(UISelectableBox).withConfig({
  displayName: "AssetCard__SelectableBox",
  componentId: "n5is04-1"
})(["border:none !important;text-align:left;"]);
const SpacedParagraph = makeSpacedComponent('p');
export const AssetCard = ({
  assetType,
  name,
  numberInstall,
  onClick,
  thumbnailUrl,
  selected
}) => {
  return /*#__PURE__*/_jsx(SelectableBox, {
    selected: selected,
    innerClassName: "text-left",
    "data-test-id": `asset-card__${assetType}:${name}`,
    children: /*#__PURE__*/_jsxs(UICardWrapper, {
      compact: true,
      onClick: onClick,
      children: [/*#__PURE__*/_jsx(SizedCardHero, {
        children: thumbnailUrl ? /*#__PURE__*/_jsx(UIImage, {
          src: thumbnailUrl
        }) : /*#__PURE__*/_jsxs(Flex, {
          marginBlock: "500",
          flexDirection: "column",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(UIIllustration, {
            name: "empty-state-charts",
            width: 200
          }), /*#__PURE__*/_jsx(SpacedParagraph, {
            marginBlockStart: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('noPreview')
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(UICardSection, {
        className: "p-all-3",
        children: [/*#__PURE__*/_jsx(H5, {
          className: "m-bottom-2",
          children: name
        }), assetType === AssetTypes.TEMPLATE && (numberInstall || numberInstall === 0) && /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('templateUsage'),
          options: {
            count: numberInstall
          }
        })]
      })]
    })
  });
};